import { isHexadecimalValue, themeInitialValue, themes } from 'app/util/theme';
import get from 'lodash.get';
import merge from 'lodash.merge';
import set from 'lodash.set';
import { DefaultTheme } from 'styled-components';

const getPrimaryColor = (styles: any, themeName: string): string => {
  const primaryColorRequested = get(styles, 'colors.primary', themes[themeName] ?? themes.default);
  return primaryColorRequested && isHexadecimalValue(primaryColorRequested)
    ? primaryColorRequested
    : themes[themeName] ?? themes.default;
};

const setThemeColors = (theme: DefaultTheme, styles: any, primaryColor: string) => {
  set(theme, 'colors.primary', primaryColor);
  set(theme, 'backgroundMode', styles?.backgroundMode ?? 'lightMode');
  set(theme, 'colors.backgroundColor', styles?.backgroundMode === 'darkMode' ? '#081133' : '#ffffff');
};

const setThemeExtras = (theme: DefaultTheme, iframe: any, button: any) => {
  set(theme, 'iframe', iframe);
  set(theme, 'button', button);
};

export const useTheme = (customStyleJSON: any): DefaultTheme => {
  const { theme: themeName = 'default', styles, iframe, button } = customStyleJSON || {};
  const theme: DefaultTheme = merge({ ...themeInitialValue }, styles);

  const primaryColor = getPrimaryColor(styles, themeName);
  setThemeColors(theme, styles, primaryColor);
  setThemeExtras(theme, iframe, button);

  return theme;
};
